import React from "react";
import { BookingType } from "../../../../../../../types/venues";

interface DiaryBookingCardBookingTypeInTimeSectionProps {
  bookingType?: BookingType | null;
  isOnRunSheet?: boolean;
}

export const DiaryBookingCardBookingTypeInTimeSection =
  React.memo<DiaryBookingCardBookingTypeInTimeSectionProps>(
    ({ bookingType, isOnRunSheet }) => {
      if (!isOnRunSheet || !bookingType) {
        return null;
      }

      return (
        <span
          className="DiarySidebarListItem__detailsType"
          style={
            {
              "--booking-type-color":
                bookingType.color ?? "hsl(var(--primary))",
              "--booking-type-foreground": bookingType.color
                ? "white"
                : "hsl(var(--primary-foreground))"
            } as React.CSSProperties
          }
        >
          <span className="DiarySidebarListItem_detailsTypeText">
            {bookingType.name}
          </span>
        </span>
      );
    }
  );

DiaryBookingCardBookingTypeInTimeSection.displayName =
  "DiaryBookingCardBookingTypeInTimeSection";
